<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    :label-position="labelPosition"
    label-width="100px"
  >
    <el-form-item
      label="规则"
      prop="ruleId"
    >
      <el-select
        v-model="form.ruleId"
        placeholder="规则名称"
        clearable
        filterable
        style="width: 100%;"
      >
        <el-option
          v-for="(item,index) in pushList"
          :key="index"
          :label="item.ruleName"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="客户姓名"
      prop="userName"
    >
      <el-input
        placeholder="请输入"
        v-model="form.userName"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="账号"
      prop="login"
    >
      <el-input
        placeholder="请输入"
        v-model="form.login"
        @input="loginInput"
        class="typeselect"
      >
      <el-select
        slot="prepend"
        v-model="form.type"
        placeholder="请选择账号类型"
        style="width: 230px;"
        @change = "loginInput"
      >
        <el-option
          v-for="(item,index) in typelist"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    
    </el-input>
    </el-form-item>
    <el-form-item
      label="备注"
      prop="remark"
    >
      <el-input
        placeholder="备注"
        v-model="form.remark"
        type="textarea"
        rows="3"
        resize="none"
      ></el-input>
    </el-form-item>

    <el-form-item
      label="状态"
      prop="status"
    >
      <el-radio
        v-model="form.status"
        :label="1"
      >启用</el-radio>
      <el-radio
        v-model="form.status"
        :label="0"
      >禁用</el-radio>
    </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
import {limitAccount,limitInt} from "@/utils/validate";

let originForm = {
  ruleId:'',
  userName: '',
  login: '',
  remark: '',
  status: 1,
  type:1
}
export default {
  name: "mt4Form",
  components:{
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          ...originForm,
        }
      }
    },
    pushList:{}
  },

  data() {
    return {
      form: {
        ...originForm,
      },
      rules:{
        ruleId: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        userName:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        login:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        type:[
          { required: true, message: '请输入', trigger: 'change' },
        ],
        remark:[
          // { required: true, message: '请输入', trigger: 'blur' },
        ],
        status:[
          { required: true, message: '请输入', trigger: 'change' },
        ],
      },
      typelist:[
        {value:1,label:"Login(MT4账号)"},
        {value:2,label:"Metaquotes ID(MT4客户端ID)"}
      ]
    }
  },
  watch:{
    formData:{
      handler(newVal,oldVal){
        if(newVal){
          this.assign(newVal);
        }
      },
      deep:true,
    },
  },
  mixins: [formLabalPosition],
  created(){
    if(this.formData.id){
      this.assign(this.formData);
    }
  },
  methods:{
    loginInput(value){
      if(this.form.type == 1){
        this.form.login =  limitInt(this.form.login);
      }else{
        this.form.login =  limitAccount(this.form.login);
      }
    },
    assign(formData){
      this.form.id = formData.id;
      this.form.ruleId = formData.ruleId;
      this.form.userName = formData.name;
      this.form.login = formData.mt4Id;
      this.form.remark = formData.remark;
      this.form.status = formData.status;
      this.form.type = formData.type;
    },
    reset(){
      this.form = {
        ...originForm,
      };
    },
    validate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .typeselect{
        .el-select{
          .el-input{
             width: 236px;
          }
        }
        .el-input-group__prepend{
          background: #fff;
        }
  }
</style>
